import {Component, Input, OnInit} from '@angular/core';
import {RegistrationRound} from '../../datamodel/registration-round';
import {Registration} from '../../datamodel/registration';

@Component({
  selector: 'app-rounds',
  templateUrl: './rounds.component.html',
  styleUrls: ['./rounds.component.css']
})
export class RoundsComponent implements OnInit {

  constructor() {
  }

  @Input()
  registration: Registration;


  ngOnInit() {
  }

}
